import { IconProps } from './IconProps';

export const CrossDark = (props: IconProps) => {
  return (
    <svg
      style={props.style}
      className={props.className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 20L4 4M20 4L4 20"
        stroke={props.fill ?? '#000000'}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

